// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XnEBl","label":"styles_label__120lG"};